import React, { useState } from 'react';
import MobHeader from 'components/UI/AtomicDesign/Molecules/MobHeader';
import Menu from 'components/Menu/Menu';
import { MobileLayoutWrapper } from './MobileLayout.styled';
import Utils from 'utils/utils';

const MobileLayout = ({ isAuthenticated, showAppbar, children }) => {
  const [showMenu, setMenu] = useState(false);

  const handleClickHamburger = (event) => {
    setMenu(!showMenu);
  };

  const handleCloseMenu = () => {
    setMenu(false);
  };

  const handleLogout = () => {
    Utils.logout();
  };

  return (
    <MobileLayoutWrapper className="mob-layout">
      {isAuthenticated && showAppbar && (
        <>
          <MobHeader onClickHamburger={handleClickHamburger} />
          <Menu handleCloseMenu={handleCloseMenu} mobileOpen={showMenu} isMobile={true} handleLogout={handleLogout} />
        </>
      )}
      {children}
    </MobileLayoutWrapper>
  );
};

export default MobileLayout;
